
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 230 256"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a","clipPathUnits":"userSpaceOnUse"}},[_c('path',{attrs:{"d":"M-63 321.5h283.5V38H-63v283.5z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)","transform":"matrix(1.33333 0 0 -1.33333 0 378)"}},[_c('path',{attrs:{"fill":"#396ba0","d":"M.3 197.9a506.7 506.7 0 0038.1 43.5l5 5.2 5 5c3.4 3.5 7 6.8 10.3 10.1l10.4 10 5.3 4.8 2.7 2.4.6.6.3.3.4.4.7.5a11.5 11.5 0 0014.8-.4l1.6-1.5 2.7-2.4 5.2-4.9c3.5-3.3 7-6.5 10.4-9.9 3.5-3.3 7-6.6 10.3-10l10-10.2c13.4-13.8 26.4-28 38.2-43.5l-.6-.7-21.6 19-21.4 19.3-21.4 19.3-10.7 9.6-5.3 4.8-2.7 2.4-1.3 1.2c-.3.3-.7.4-1 .4-.4 0-.8 0-1-.3l-1.3-1.2-2.7-2.4-5.3-4.8-10.7-9.6-21.4-19.3-21.4-19.3L1 197.2l-.7.7z"}}),_c('path',{attrs:{"fill":"#535253","d":"M130 207l-.1-115h-3.3l-8 57-15.5 1.6c-4.5.3-29 .3-33.5 0L54.1 149l-8-57h-3.3v114.8c0 1.4 1.1 2.6 2.6 2.6h6c1.5 0 2.6-1.2 2.6-2.7v-47.5h64.6V207c0 1.4 1.1 2.5 2.5 2.5h6.4c1.3 0 2.4-1 2.4-2.4"}})])])
          )
        }
      }
    